import React from "react";
import styles from './Real.module.css';
import improveImg from '../../assets/home/edrill.png';

const Real = () => {
    return(
        <div className="mb-5 overflow-hidden">
            <div className="row g-0">
                <div className={`col-md-6 ${styles.imgDiv}`}>
                    {/* Updated the image container to better align on large screens */}
                    <div className={styles.imageContainer}>
                        <img data-aos='slide-right' data-aos-offset="150" src={improveImg} alt="" className={styles.img}/>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className={styles.text}>
                        <p data-aos='slide-right' data-aos-offset="150"  className={styles.heading}>Terpercaya dan Bikin Happy!</p>
                        <p data-aos='slide-left' data-aos-offset="150" className={styles.subHeading}>Tingkatkan kualitas bangunan impian Anda dengan Bale Mart!</p>
                        <p data-aos='zoom-in' data-aos-offset="150" className={styles.content}>Sejak tahun 2020, kami hadir sebagai minimarket bahan bangunan terpercaya yang menyediakan beragam produk berkualitas tinggi dengan harga yang bersaing. Mulai dari material dasar yang kokoh, peralatan kerja yang handal, hingga sentuhan akhir yang menawan, semua kebutuhan konstruksi dan renovasi Anda tersedia praktis di satu tempat. Didukung oleh PT. Waskita Arya Rahayu Utama yang berpengalaman dan kini berstatus Pengusaha Kena Pajak (PKP), Bale Mart adalah mitra tepat untuk mewujudkan setiap detail proyek Anda, baik skala besar maupun kecil. </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Real;